<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  @if (algorithmVersion === 1) {
    <div class="monitor_container-column monitor_container-column--single">
      <div class="monitor_graph-box monitor_graph-box--single" #plotContainerOS>
        <ng-container *ngTemplateOutlet="leftPlot"></ng-container>
      </div>
    </div>
    <div class="monitor_container-column monitor_container-column--single">
      <div class="monitor_graph-box monitor_graph-box--single" #plotContainerOD>
        <ng-container *ngTemplateOutlet="rightPlot"></ng-container>
      </div>
    </div>
  } @else {
    <div class="monitor_container-column">
      <div class="monitor_graph-box" #plotContainerOS>
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <ng-container *ngTemplateOutlet="leftPlot"></ng-container>
      </div>
      <div class="monitor_graph-box" #plotContainerOD>
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <ng-container *ngTemplateOutlet="rightPlot"></ng-container>
      </div>
    </div>
    <div class="monitor_container-column">
      <div class="monitor_graph-box monitor_graph-box--single">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title monitor_graph-title--center">
          @if (location && algorithmVersion === 3) {
            <span>{{ 'location' | translate | titlecase }}{{'&nbsp;&#35;' + location}} &nbsp;&nbsp;</span>
          }
          @if (attempt) {
            <span>{{ 'attempt' | translate | titlecase }}{{'&nbsp;&#35;' + attempt}}</span>
          }
        </div>
        <app-percentage-circle
          id="test-percentage"
          class="monitor_circle-box"
          [percentage]="percentage">
        </app-percentage-circle>
      </div>
    </div>
  }

</app-monitor-layout>



<ng-template #leftPlot>
  @if (!isWarmup) {
    <div class="monitor_graph-title">
      {{ 'left' | translate | titlecase }}
      @if (test?.eye === 'OS') {
        <span> <small>({{'movableTarget' | translate}})</small></span>
      }
    </div>
    @if (layoutOS) {
      <plotly-plot [data]="osData" [layout]="layoutOS" [config]="monitorTestService.plotOptions"
        [revision]="count" [debug]="true" class="monitor_plot-box">
      </plotly-plot>
    }
  } @else {
    <div class="monitor_eye-box">
      <app-hourglass [offset]="50"></app-hourglass>
    </div>
  }
</ng-template>

<ng-template #rightPlot>
  @if (!isWarmup) {
    <div class="monitor_graph-title">
      {{ 'right' | translate | titlecase }}
      @if (test?.eye === 'OD') {
        <span> <small>({{'movableTarget' | translate}})</small></span>
      }
    </div>
    @if (layoutOD) {
      <plotly-plot [data]="odData" [layout]="layoutOD" [config]="monitorTestService.plotOptions"
        [revision]="count" [debug]="true" class="monitor_plot-box">
      </plotly-plot>
    }
  } @else {
    <div class="monitor_eye-box">
      <app-hourglass [offset]="50"></app-hourglass>
    </div>
  }
</ng-template>

